import { cn } from "@/app/lib/utils/cn";

export default function LoadingSpinner({className}: {className?: string}) {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className={cn('h-32 w-32 animate-spin rounded-full border-b-2 border-t-2 border-GREEN-500', className)} />
    </div>
  );
}
